import { ImResponse, doorClient, resolve } from '.';

/**
 * 当前org是否开通了ai快捷短语
 * true 开通了 ai快捷短语
 * false 没开通 ai快捷短语，同时没开通意味着“开通了问答(QA)”
 */
export function status() {
  return resolve(
    doorClient.get<ImResponse<{ enable: boolean }>>(
      '/overseaim-store-home/v1/org-config/aiReplyRecommendStatus',
    ),
  );
}

export interface ListParams {
  conversationId: string;
  timeZone: number;
  offset?: string;
  pageSize?: number;
}

export interface ListResponse {
  hasNext: boolean;
  conversationAiReply: Conversation.AIReply.QueryReply[];
}

export function list(params: ListParams) {
  return resolve(
    doorClient.get<ImResponse<ListResponse>>(
      '/oversea-conversation/v1/aiReply/conversationAiReply',
      {
        params,
      },
    ),
  );
}

export interface TranslationReportBody {
  aiReplyTranslateReportInfo: {
    replyId: string;
    translation: {
      text: string;
      source: string;
      targetLanguage: string;
    };
  }[];
}

export function translationReport(body: TranslationReportBody) {
  return resolve(doorClient.post('/oversea-conversation/v1/aiReply/aiReplyTranslateReport', body));
}
